import React from "react";
import SelectMembership from "./SelectMembership";
import Banner from "./Banner";

const Membership = () => {
  return (
    <>
      <Banner />
      <SelectMembership />
    </>
  );
};

export default Membership;
